import React from "react";
import "./Modal.css";
import FlowerLoader from "./FlowerLoader";

const LoaderModal = () => {
  return (
    <div
      className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50"
      role="dialog"
    >
      <div
        className="relative p-6"
      >
        <div className="rounded-lg shadow bg-transparent duration-300 p-6">
          {/* Loader */}
          <div className="flex justify-center items-center">
            <div className="loader"><FlowerLoader/></div> {/* Add your loader component or HTML/CSS loader here */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderModal;
